/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import { Table, Button } from 'antd'
import {
  changeToDecimal,
  clickDownload,
  copyToClip,
  round,
} from '../../../util/index'

export default class extends React.Component {
  //求和(金额)
  priceSum = (list) => {
    let sum = 0
    list.map((item) => {
      sum += +item.benefit
    })
    return sum.toFixed(2)
  }
  render() {
    const { record, storage } = this.props
    const columns = [
      {
        title: '操作时间',
        dataIndex: 'ctime',
        width: '11%',
      },
      {
        title: '期初平均成本单价',
        dataIndex: 'cost_init',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '期初数量',
        dataIndex: 'qty_init',
        width: '5.5%',
      },
      {
        title: '期初成本总额',
        dataIndex: 'amount_init',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '入库单价',
        dataIndex: 'cost_income',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '入库数量',
        dataIndex: 'qty_income',
        width: '5.5%',
      },
      {
        title: '入库金额',
        dataIndex: 'amount_income',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '销售单价',
        dataIndex: 'price_sale',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '销售数量',
        dataIndex: 'qty_sale',
        width: '5.5%',
      },
      {
        title: '销售金额',
        dataIndex: 'amount_sale',
        width: '5.9%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '库存平均成本单价',
        dataIndex: 'cost_balance',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '库存数量',
        dataIndex: 'qty_balance',
        width: '5.5%',
      },
      {
        title: '库存成本总额',
        dataIndex: 'amount_balance',
        width: '5.5%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '利润',
        dataIndex: 'benefit',
        width: '3.8%',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '流水号',
        dataIndex: 'serial_number',
      },
      {
        title: '操作人',
        dataIndex: 'employee_name',
        width: '5.5%',
      },
    ]

    const data = storage.list.map((item) => {
      item.amount_init = round(+item.amount_init / 100, 2)
      item.cost_init = round(+item.cost_init / 100, 2)
      item.cost_income = round(+item.cost_income / 100, 2)
      item.amount_income = round(+item.amount_income / 100, 2)
      item.cost_balance = round(+item.cost_balance / 100, 2)
      item.amount_balance = round(+item.amount_balance / 100, 2)
      item.amount_sale = round(+item.amount_sale / 100, 2)
      item.price_sale = round(+item.price_sale / 100, 2)
      if (record.non_standard == 1) {
        item.benefit = '--'
      } else {
        item.benefit = +item.benefit / 100
      }

      return item
    })

    let reportName = sessionStorage.getItem('reportName')
    const sum = this.priceSum(data)
    return (
      <div>
        <div className="commodity-title">
          <div className="diamond-item">
            <span>商品库存:</span>
            <h3 style={{ marginLeft: '1.7rem' }}>{record.balance}</h3>
          </div>
          <Button
            type="primary"
            style={{ marginLeft: '1rem' }}
            ghost
            onClick={() => copyToClip(sum)}
          >
            利润合计:￥{sum}元
          </Button>
        </div>
        {/*<div className="diamond-item">*/}
        {/*<span>商品冻结数:</span>*/}
        {/*<h3 style={{marginLeft:'1.7rem',color: 'red'}}>{storage.info.freeze}</h3>*/}
        {/*{storage.info.freeze != 0 &&*/}
        {/*<Button type="primary" danger size="small" onClick={() => this.props.fetchRemoveFreeze(storage.info.id)} style={{marginLeft: '2rem'}}>解冻</Button>*/}
        {/*}*/}
        {/*</div>*/}
        <div className="outcome">
          <h3>商品流水</h3>
          <Button className="outcome-btn">
            <a
              id="test"
              href={clickDownload(columns, data)}
              download={`${reportName}-商品流水.csv`}
            >
              导出流水
            </a>
          </Button>
        </div>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={data}
          size="small"
          scroll={{ y: 300 }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/commodityStorage.js